export default __webpack_public_path__ + "static/media/whatsapp.84b43df0.svg";